import iconPath from '@/assets/device-icons/iphone-se.svg';

interface IphoneSeIconProps {
  className?: string;
}

export const IphoneSeIcon = ({ className = "h-5 w-5" }: IphoneSeIconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="iPhone SE" 
      className={className}
    />
  );
};
